// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary-color: #00664f;
    --header-height: 75px;
    --primary-color-dark: #005a4f;
}

html {
    background-color: var(--primary-color);
}
.main-body {
    padding: 20px;
    margin-top: var(--header-height);
}

.material-symbols-outlined {
    vertical-align: middle;
    margin: 0 5px;
}

.centered-text {
    text-align: center;
}


.wiggling {
    display: inline-block;
    animation: wiggle 1.8s linear infinite;

}
.spinning {
    display: inline-block;
    animation: spin 2s linear infinite;
}

.loading-screen {
    min-width: 400px;
    min-height: 400px;
    text-align: center;
    color: var(--primary-color);
    font-size: 1.2em;
    margin-top: 150px;
}

.loading-screen .wiggling {
    margin: 20px;
    width: 75px;
    height: 75px;
}



button {
    margin: 10px 0;
    /*a nice large button that's easy to see and click*/
    padding: 10px 32px;
    font-size: 1.2em;
    background-color: #00664f;
    color: white;
    border: none;
    border-radius: 5px;
    cursor: pointer;
}
button:hover {
    background-color: #005a4f;
}

.clickable {
    cursor: pointer;
    text-decoration: underline;
}
.clickable:hover {
    color: #005a4f;
}

.environment-indicator {
    color: red;
    font-weight: bold;
    font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;AACA;IACI,aAAa;IACb,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,qBAAqB;IACrB,sCAAsC;;AAE1C;AACA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;AAChB;;;;AAIA;IACI,cAAc;IACd,mDAAmD;IACnD,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[":root {\n    --primary-color: #00664f;\n    --header-height: 75px;\n    --primary-color-dark: #005a4f;\n}\n\nhtml {\n    background-color: var(--primary-color);\n}\n.main-body {\n    padding: 20px;\n    margin-top: var(--header-height);\n}\n\n.material-symbols-outlined {\n    vertical-align: middle;\n    margin: 0 5px;\n}\n\n.centered-text {\n    text-align: center;\n}\n\n\n.wiggling {\n    display: inline-block;\n    animation: wiggle 1.8s linear infinite;\n\n}\n.spinning {\n    display: inline-block;\n    animation: spin 2s linear infinite;\n}\n\n.loading-screen {\n    min-width: 400px;\n    min-height: 400px;\n    text-align: center;\n    color: var(--primary-color);\n    font-size: 1.2em;\n    margin-top: 150px;\n}\n\n.loading-screen .wiggling {\n    margin: 20px;\n    width: 75px;\n    height: 75px;\n}\n\n\n\nbutton {\n    margin: 10px 0;\n    /*a nice large button that's easy to see and click*/\n    padding: 10px 32px;\n    font-size: 1.2em;\n    background-color: #00664f;\n    color: white;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n}\nbutton:hover {\n    background-color: #005a4f;\n}\n\n.clickable {\n    cursor: pointer;\n    text-decoration: underline;\n}\n.clickable:hover {\n    color: #005a4f;\n}\n\n.environment-indicator {\n    color: red;\n    font-weight: bold;\n    font-size: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
